import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="tabs"
export default class extends Controller {
  static values = {
    fromClass: String,
    toClass: String,
  };

  static targets = ['tab'];

  connect() {
    // Apply initial styles
    if (this.hasTabTarget) {
      this.tabTargets.forEach((tab) => {
        tab.addEventListener('click', this.handleClick.bind(this));
      });
    }
  }

  handleClick(event) {
    this.activate(event.currentTarget);
  }

  activate(element) {
    // Remove active class from all tabs
    this.tabTargets.forEach((tab) => {
      tab.classList.remove(this.toClassValue);
      tab.classList.add(this.fromClassValue);
    });

    // Add active class to clicked tab
    element.classList.remove(this.fromClassValue);
    element.classList.add(this.toClassValue);
  }
}
